module.exports = __webpack_public_path__ + "img/CompScope_Mag_4_Focus_1.69f9b019.png";